
export const config = {
    S3imgHostUrl : "https://pawwalker-files.s3.ap-south-1.amazonaws.com"
}